import React, { useEffect, useRef, useState } from 'react';
import OTPInput from 'react-otp-input';
import { toast } from 'sonner';
import { uploadImage } from '../../../api/api.global';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { PROFILE } from '../../../statics/localStorage';
import { encryptLocalStorage } from '../../../utils/localStorage.utils';

const ProfileTab = () => {
    const [showOtpBtn, setShowOtpBtn] = useState(true);
    const [profileData, setProfileData] = useState(PROFILE())
    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);
    const [otpView, setOtpView] = useState(null);
    const [otpResp, setOtpResp] = useState(null);
    const [otp, setOtp] = useState(null);

    const getMyProfile = async () => {
        let resp = await getApi(urlApi.getMyProfileData);
        if (resp.responseCode === 200) {
            encryptLocalStorage('profile', resp.data);
            setProfileData(resp.data);
        } else {
            setProfileData({});
            encryptLocalStorage('profile', {});
        }
    }

    useEffect(() => {
        getMyProfile();
        return () => {

        };
    }, []);

    const handleImageChange = (e) => {
        setFile(e.target.files[0]);
    }

    async function update() {
        loadingShow();
        let postData = {
            name: document.getElementById('display-name')?.value?.trim(),
            profilePic: file ? await uploadImage(file, 'advy-profile-pictures') : profileData?.profilePic
        }
        if (document.getElementById('website').value?.trim()) {
            postData.website = document.getElementById('website').value?.trim();
        }
        if (document.getElementById('company').value?.trim()) {
            postData.company = document.getElementById('company').value?.trim();
        }
        let resp = await postApi(postData, urlApi.updateProfile);
        loadingHide();
        if (resp.responseCode === 200) {
            getMyProfile();
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    async function getOtp(postKey) {
        let postData = {};
        postData[postKey] = document.getElementById(postKey).value?.trim();
        loadingShow();
        let resp = await postApi(postData, urlApi.getOtpForUpdate);
        loadingHide();
        if (resp.responseCode === 200) {
            setOtpResp(resp?.data);
            setOtpView(postKey);
        } else {
            toast.error(resp.message);
        }
    }

    async function updateCredential(postKey) {
        let postData = {
            "otp": otp,
            "otpId": otpResp.otpId
        }
        postData[postKey] = document.getElementById(postKey).value?.trim();
        loadingShow();
        let resp = await postApi(postData, urlApi.verifyCredential);
        loadingHide();
        if (resp.responseCode === 200) {
            setShowOtpBtn(false);
            setOtpView(null);
            setOtp(null);
            setOtpResp(null);
            toast.success(resp.message);
            getMyProfile();
        } else {
            toast.error(resp.message);
        }
    }

    // const ingest = async () => {
    //     loadingShow();
    //     let resp = await getApi(urlApi.ingestSite);
    //     loadingHide();
    //     if (resp.responseCode === 200) {
    //         toast.success(resp.message);
    //     } else {
    //         toast.error(resp.message);
    //     }
    // }

    return (
        <>
            <div className='bg-white px-3 pt-2 pb-5 rounded-lg !mb-4'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mb-3'>
                    <div className="block">
                        <label htmlFor="display-name" className='text-sm font-semibold mb-1.5'>Display Name</label>
                        <input type="text" id="display-name" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your display name" defaultValue={profileData?.name} />
                    </div>
                    <div className="block">
                        <label htmlFor="company" className='text-sm font-semibold mb-1.5'>Company Name</label>
                        <input type="text" id="company" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Your company name" defaultValue={profileData?.company} />
                    </div>
                    <div className="block">
                        <label htmlFor="website" className='text-sm font-semibold mb-1.5'>Website URL</label>
                        <div className='flex items-center gap-3'><input type="text" id="website" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your Website" defaultValue={profileData?.website} />
                            {/* <button className='border-2 rounded-md px-4 py-1' onClick={ingest}>Ingest*</button> */}
                        </div>
                        {/* <p className="text-xs italic text-orange-500 mt-0.5">*Click Ingest if you want to integrate AI support in your Site's live Chat</p> */}
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                    <img src={file ? URL.createObjectURL(file) : profileData?.profilePic ? profileData?.profilePic : (process.env.PUBLIC_URL + "/images/image-upload.png")} id='link-image-preview' className='max-w-[140px] max-h-[200px] rounded-lg object-cover' alt="" />
                    <button className="primary-outline-btn" onClick={() => imageUploadInputRef.current.click()}>Select Profile Picture</button>
                </div>
                <div className='mb-5 flex justify-end'>
                    <button className='text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full' onClick={() => update()}>Update</button>
                </div>
                <hr className='mb-5' />
                <div className="grid grid-cols-2 gap-3">
                    <div className="block">
                        <label htmlFor="email" className='text-sm font-semibold mb-1.5'>Email (OTP Required)</label>
                        <input type="text" id="email" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your email" defaultValue={profileData?.email} disabled={(profileData?.loginBy == 2) || (profileData?.email)} readOnly={profileData?.loginBy == 2} />

                        {
                            otpView == "email" &&
                            <form onSubmit={(e) => { e.preventDefault(); updateCredential('email') }} className='flex flex-col mt-6 mb-6 px-16'>
                                <OTPInput
                                    containerStyle={{ gap: '6px' }}
                                    inputStyle={{ width: '50px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', height: 50, borderRadius: 10, backgroundColor: 'transparent', border: '2px solid #dddddd', fontWeight: 'bold' }}
                                    value={otp}
                                    onChange={setOtp}
                                    shouldAutoFocus={true}
                                    inputType='tel'
                                    numInputs={6}
                                    renderSeparator={<span>&nbsp;</span>}
                                    renderInput={(props) => <input {...props} />}
                                />

                                <button className='w-full py-2.5 !bg-primary rounded-full mt-8 font-semibold text-md text-white'>Update</button>

                            </form>}
                        {(otpView != 'email' && profileData?.loginBy != 2 && !profileData?.email && showOtpBtn) && <button className='float-end text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full mt-2' onClick={() => getOtp('email')} >Get OTP</button>}
                    </div>
                    <div className="block">
                        <label htmlFor="phone" className='text-sm font-semibold mb-1.5'>Mobile (OTP Required)</label>
                        <input type="tel" id="phone" maxLength={10} className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter Your mobile" defaultValue={profileData?.phone} disabled={(profileData?.loginBy == 1) || (profileData?.phone != null)} readOnly={profileData?.loginBy == 1} />
                        {
                            otpView == "phone" &&
                            <form onSubmit={(e) => { e.preventDefault(); updateCredential('phone') }} className='flex flex-col mt-6 mb-6 px-16'>
                                <OTPInput
                                    containerStyle={{ gap: '6px' }}
                                    inputStyle={{ width: '50px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', height: 50, borderRadius: 10, backgroundColor: 'transparent', border: '2px solid #dddddd', fontWeight: 'bold' }}
                                    value={otp}
                                    onChange={setOtp}
                                    shouldAutoFocus={true}
                                    inputType='tel'
                                    numInputs={6}
                                    renderSeparator={<span>&nbsp;</span>}
                                    renderInput={(props) => <input {...props} />}
                                />

                                <button className='w-full py-2.5 !bg-primary rounded-full mt-8 font-semibold text-md text-white'>Update</button>

                            </form>}
                        {(otpView != 'phone' && profileData?.loginBy != 1 && !profileData?.phone && showOtpBtn) && <button className='float-end text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full mt-2' onClick={() => getOtp('phone')}>Get OTP</button>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileTab